import { createContext } from 'react';

const DecedentFilterContext = createContext();

export default DecedentFilterContext;
